module.exports = __webpack_public_path__ + "static/img/3_25.9fb42f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3_25.png
// module id = 5O8R
// module chunks = 3